import { OwlDateTimeFormats } from '@danielmoncada/angular-datetime-picker';
import { enUS, de, fr, hu, it, ja, pl, pt, ro, ru, uk, zhCN, th, tr, cs, es, sk, sr, Locale } from 'date-fns/locale';

export const APP_DEFAULT_TIMEZONE = 'UTC';

export const DISPLAY_DATE_FORMAT = 'MMM d, y HH:mm';
export const PUBLIC_TRACKING_DATE_FORMAT = 'MMM d, y HH:mm a';
export const DISPLAY_DATE_HOURS_FIRST_FORMAT = 'HH:mm MMMM d, y';
export const SHORT_DISPLAY_DATE_FORMAT = 'MMM d, y';
export const SHORT_DISPLAY_MINUTES_ONLY_FORMAT = 'mm';
export const DATEPICKER_DISPLAY_DATE_FORMAT = 'MMMM DD, y';
export const DATEPICKER_DISPLAY_HOUR_ONLY_FORMAT = 'HH';
export const DATE_TIME_PICKER_DISPLAY_DATE_FORMAT = 'MMMM D, y HH:mm';
export const DATE_TIME_PICKER_DISPLAY_DATE_12H_FORMAT = 'MMMM D, y hh:mm A';
export const DATE_TIME_PICKER_DISPLAY_DATE_HOURS_FIRST_FORMAT = 'HH:mm MMMM D';
export const DATE_ISO_FORMAT_DATE_FNS = 'yyyy-MM-dd';
export const TIME_SHORT_FORMAT = 'HH:mm';
export const TIME_12HOUR_FORMAT = 'hh:mm A';
export const TIME_MASK_MIN_SEC_FORMAT = '00:00';
export const DAY_MONTH_FORMAT = 'DD MMMM';
export const DAY_OF_WEEK_FORMAT = 'dddd';
export const TIMEPICKER_DISPLAY_FORMAT = 'HH:mm';
export const DISPLAY_DATE_TIME_FIRST_FORMAT = 'HH:mm MMMM DD, y';
export const DISPLAY_DATE_IN_CANARY_TP = 'dd-MM-yy HH:mm';
export const DISPLAY_DATE_IN_CANARY_TP_LOCALE = 'DD-MM-yy HH:mm';
export const LOCALE_DEFAULT_FORMAT = 'll LT';
export const LOCALE_SHORT_DISPLAY_DATE_FORMAT = 'll';
export const LOCALE_TIME_SHORT_FORMAT = 'LT';
export const YEAR_DATE_FORMAT = 'yyyy';
export const EMPTY_TIME_PLACEHOLDER = '___:___';

export const DAY_IN_MS = 86400000;
export const HOURS_IN_DAY = 24;
export const MINUTES_IN_HOUR = 60;
export const SECONDS_IN_MIN = 60;
export const MINUTES_IN_DAY = HOURS_IN_DAY * MINUTES_IN_HOUR;
export const SECOND_IN_MS = 1000;
export const MS_IN_MIN = SECONDS_IN_MIN * SECOND_IN_MS;

export const DATEPICKER_CONFIG = {
  parse: {
    dateInput: DATEPICKER_DISPLAY_DATE_FORMAT,
  },
  display: {
    dateInput: DATEPICKER_DISPLAY_DATE_FORMAT,
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const DATE_TIMEPICKER_CONFIG: OwlDateTimeFormats = {
  parseInput: DATE_TIME_PICKER_DISPLAY_DATE_FORMAT,
  fullPickerInput: DATE_TIME_PICKER_DISPLAY_DATE_FORMAT,
  datePickerInput: DATEPICKER_DISPLAY_DATE_FORMAT,
  timePickerInput: TIMEPICKER_DISPLAY_FORMAT,
  ...DATEPICKER_CONFIG.display,
};

export const MODIFIED_DATE_TIMEPICKER_CONFIG = {
  ...DATE_TIMEPICKER_CONFIG,
  fullPickerInput: LOCALE_DEFAULT_FORMAT,
  datePickerInput: LOCALE_SHORT_DISPLAY_DATE_FORMAT,
};

export enum TimeUnit {
  Day = 'day',
  Date = 'date',
  Hour = 'hour',
  Hours = 'hours',
  Minute = 'minute',
  MinuteShort = 'm',
  Minutes = 'minutes',
  Second = 'second',
}

type LocaleLanguageMap = {
  [languageCode: string]: string;
};

export const LOCALE_CODE_LIST: LocaleLanguageMap = {
  DE: 'de',
  CS: 'cs',
  EN: 'en',
  ES: 'es',
  FR: 'fr',
  HU: 'hu',
  SK: 'sk',
  SR: 'sr',
  IT: 'it',
  JA: 'ja',
  PL: 'pl',
  PT: 'pt',
  PT_BR: 'pt_br',
  RO: 'ro',
  RU: 'ru',
  UK: 'uk',
  ZH: 'zh',
  HI: 'hi',
  TH: 'th',
  TR: 'tr',
};

export const DATE_FNS_LOCALE_MAP: Record<string, Locale> = {
  en: enUS,
  de,
  fr,
  hu,
  it,
  ja,
  pl,
  pt,
  ro,
  ru,
  uk,
  zh: zhCN,
  th,
  tr,
  cs,
  es,
  sk,
  sr,
};
